export default __webpack_public_path__ + "static/testimonials_people_bg-160b57aa9ffba9bc031797e131cecb48.jpeg";